import { render, staticRenderFns } from "./logisticSupply.vue?vue&type=template&id=143a5123&scoped=true"
import script from "./logisticSupply.vue?vue&type=script&lang=js"
export * from "./logisticSupply.vue?vue&type=script&lang=js"
import style0 from "./logisticSupply.vue?vue&type=style&index=0&id=143a5123&prod&lang=css"
import style1 from "./logisticSupply.vue?vue&type=style&index=1&id=143a5123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143a5123",
  null
  
)

export default component.exports